import { AjaxService } from "../Helpers/AjaxService";
import { Crop } from "../Models/Crops/Crop";
import { CollectedStorageCropInfo } from "../Models/Crops/CollectedStorageCropInfo";
import { DeliveryGroupedByCropNumber } from "../Models/Crops/DeliveryGroupedByCropNumber";
import { SamplesGroupByCropNumber } from "../Models/Crops/SamplesGroupByCropNumber";
import { CleanedSeedsGroupedByCropNumber } from "../Models/Crops/CleanedSeedsGroupedByCropNumber";
import { CropActiveYear } from "../Models/Crops/CropActiveYear";
export class CropsApi {
    private static instance: CropsApi;
    static getInstance() { return CropsApi.instance || (CropsApi.instance = new CropsApi()); }

    getCrops(): Promise<Crop[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getcrops`;
        return new Promise<Crop[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: Crop[]) => {
                    resolve(result);
                });
        });
    }

    getCollectedStorageCropInfo(): Promise<CollectedStorageCropInfo> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getcollectedstoragecropinfo`;
        return new Promise<CollectedStorageCropInfo>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: CollectedStorageCropInfo) => {
                    resolve(result);
                });
        });


    }
    getDeliveries(): Promise<DeliveryGroupedByCropNumber[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getdeliveries`;
        return new Promise<DeliveryGroupedByCropNumber[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: DeliveryGroupedByCropNumber[]) => {
                    result.forEach(deliveryGroup => {
                        deliveryGroup.Deliveries.forEach(delivery => {
                            //delivery.DeliveryDate = this.getDateString(new Date(parseInt(accountStatement.PostedAt.substr(6))));
                            const milli = delivery.DeliveryDate.toString().replace(/\/Date\((-?\d+)\)\//, '$1');
                            delivery.DeliveryDate = new Date(parseInt(milli));
                        });
                    });
                    resolve(result);
                });
        });
    }
    getSamples(): Promise<SamplesGroupByCropNumber[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getsamples`;
        return new Promise<SamplesGroupByCropNumber[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: SamplesGroupByCropNumber[]) => {
                    resolve(result);
                });
        });
    }
    getCleanedSeeds(): Promise<CleanedSeedsGroupedByCropNumber[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getcleanedseeds`;
        return new Promise<CleanedSeedsGroupedByCropNumber[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: CleanedSeedsGroupedByCropNumber[]) => {
                    resolve(result);
                });
        });
    }
    getActiveCrops(): Promise<CropActiveYear[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/crops/getcropactiveyears`;
        return new Promise<CropActiveYear[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: CropActiveYear[]) => {
                    resolve(result);
                });
        });
    }

}